import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendorIcon from "../../assets/icons/calendor-icon";

const DatePickerInput = ({
  placeholder = "",
  onChange = () => {},
  value,
  className = "w-full bg-transparent focus:outline-none text-[var(--head-input-fg-color)] text-[length:var(--head-input-font-size)] font-[var(--head-input-font-weight)] placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:var(--head-input-font-size)] placeholder:font-[var(--head-input-place-font-weight)]",
  conClass = "",
  width = "150px",
  height = "32px",
  borderClass = "border-[var(--head-input-border-color)]",
  maxDate = null,
  minDate = null,
  isDisabled = false,
  // Renders the calendar popup into a portal under document.body instead of
  // inline — needed when this sits inside an ancestor with overflow:hidden
  // (e.g. an animated collapsible panel), which would otherwise clip it.
  portalId,
  // "left" keeps every existing caller's layout unchanged; pass "right" to
  // place the icon after the input instead.
  iconPosition = "left",
}) => {
  const datePickerRef = useRef(null);

  const icon = (
    <button
      type="button"
      tabIndex={-1}
      disabled={isDisabled}
      onClick={() => datePickerRef.current?.setOpen(true)}
      className={isDisabled ? "cursor-not-allowed" : "cursor-pointer"}
    >
      <CalendorIcon width="14px" height="14px" />
    </button>
  );

  return (
    <div
      style={{
        height,
        width,
      }}
      className={`flex items-center border ${borderClass} rounded-md gap-[8px] px-2 z-20 ${isDisabled ? "bg-gray-100 cursor-not-allowed" : ""} ${conClass}`}
    >
      {iconPosition === "left" && icon}
      <DatePicker
        ref={datePickerRef}
        wrapperClassName="flex-1 min-w-0"
        {...(portalId ? { portalId, popperClassName: "!z-[9999]" } : {})}
        isClearable={!isDisabled}
        disabled={isDisabled}
        selected={value ? new Date(value) : null} // Ensure value is a Date object
        onChange={
          (date) => onChange(date ? date.toLocaleDateString("sv-SE") : "")
          // 👈 Return empty string instead of null
        }
        dateFormat="yyyy-MM-dd"
        placeholderText={placeholder}
        onKeyDown={(e) => e.preventDefault()} // 👈 Prevent manual typing
        className={`${className} ${isDisabled ? "cursor-not-allowed" : ""}`}
        maxDate={maxDate ? new Date(maxDate) : null} // 👈 Add maxDate prop
        minDate={minDate ? new Date(minDate) : null} // 👈 Add minDate prop
      />
      {iconPosition === "right" && icon}
    </div>
  );
};

export default DatePickerInput;
